import { render, staticRenderFns } from "./2.vue?vue&type=template&id=f2cc94e8&scoped=true&"
var script = {}
import style0 from "./2.vue?vue&type=style&index=0&id=f2cc94e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cc94e8",
  null
  
)

export default component.exports